// TabContentWrapper.jsx
import { Box } from '@mui/material';

const TabContentWrapper = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: '100vh',
      gap: 4,
      px: 2,
      boxSizing: 'border-box',
      overflowY: 'auto',
    }}
  >
    {children}
  </Box>
);

export default TabContentWrapper;
